<template>
  <!-- 到期汇总条：登录进来第一眼就能看到「几台已过期 / 几台即将到期」，
       不用翻列表数红行。4 个到期提醒列表共用。 -->
  <div v-if="total" class="expiry-summary">
    <span class="es-item es-danger">已过期 <b>{{ expired }}</b> {{ unit }}</span>
    <span class="es-divider" />
    <span class="es-item es-warning">30 天内到期 <b>{{ soon }}</b> {{ unit }}</span>
    <span class="es-divider" />
    <span class="es-item">合计 <b>{{ total }}</b> {{ unit }}</span>
  </div>
</template>

<script>
export default {
  name: 'ExpirySummary',
  props: {
    expired: { type: Number, default: 0 },
    soon: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    // 单位：设备/阀门用「台」，场所性能用「个」
    unit: { type: String, default: '台' },
  },
}
</script>

<style scoped>
/* 配色要在暖米白底（App.vue 全局 #f6f1e7）上看得出来：
   红用小标题级 #f56c6c、橙用 #e6a23c，数字放大加粗，扫一眼就能抓住重点。 */
.expiry-summary {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0 0 12px;
  padding: 9px 14px;
  background: #fff;
  border: 1px solid #e3dcc8;
  border-left: 3px solid #d9d0b8;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}
.es-item b {
  font-size: 16px;
  font-weight: 700;
  margin: 0 2px;
}
.es-danger b {
  color: #f56c6c;
}
.es-warning b {
  color: #e6a23c;
}
.es-divider {
  width: 1px;
  height: 14px;
  background: #e3dcc8;
}
</style>
